import Vue from 'vue';
import Vuex from 'vuex';
import http from '../api/http';

Vue.use(Vuex);

const TOKEN_KEY = 'admin_token';

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: null
  },
  mutations: {
    SET_TOKEN(state, t) {
      state.token = t || '';
      if (t) localStorage.setItem(TOKEN_KEY, t);
      else localStorage.removeItem(TOKEN_KEY);
    },
    SET_USER(state, u) {
      state.user = u;
    },
    CLEAR_AUTH(state) {
      state.token = '';
      state.user = null;
      localStorage.removeItem(TOKEN_KEY);
    }
  },
  getters: {
    isAdmin: (s) => s.user && s.user.roleCode === 'ADMIN',
    isCs: (s) => s.user && s.user.roleCode === 'CS'
  },
  actions: {
    async login({ commit }, { username, password }) {
      const { data } = await http.post('/admin/auth/login', { username, password });
      const payload = data.data || data;
      commit('SET_TOKEN', payload.token);
      commit('SET_USER', payload.user);
    },
    async loadMe({ commit }) {
      const { data } = await http.get('/admin/auth/me');
      const u = data.data || data;
      commit('SET_USER', u);
    },
    logout({ commit }) {
      commit('CLEAR_AUTH');
    }
  }
});
